import type { Export } from '../../types';

export const addExportIfValueExists = (exports: Export[], newExport: Export) =>
  newExport.value && exports.push(newExport);
